// 引入axios并配置
import axios from "axios";
import { Loading, Message } from "element-ui"; //引入Loading服务
//开始加载动画
let loading;
function startLoading() {
  loading = Loading.service({
    lock: true, //是否锁定
    text: "拼命加载中..." //加载中需要显示的文字
  });
}
//结束加载动画
function endLoading() {
  loading.close();
}

// 给axios配置请求拦截器;

axios.interceptors.request.use(
  config => {
    startLoading(); //请求时的加载动画

    var token = window.sessionStorage.getItem("userId");
    config.headers.userId = token;
    return config;
  },
  ereor => {
    // console.log(ereor);
    return Promise.reject(ereor);
  }
);
//相应拦截
axios.interceptors.response.use(
  response => {
    endLoading(); //结束加载动画
    return response; //结束时把response return回去
  },
  error => {
    //错误提醒
    endLoading(); //如果错误也结束动画
    Message.error(error.response.data);
    return Promise.reject(error);
  }
);

// 基准路径
// axios.defaults.withCredentials = true;

axios.defaults.baseURL = BASEURL;

export default axios;
